import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { translate } from 'react-i18next'
import { Text, CopyToClipboard, Icon } from 'components'
import PHASE, { phaseToNumber } from 'utils/constants/phases'
import { flatten } from 'lodash'
import { BreadCrumb } from './BreadCrumb/BreadCrumb'
import { Timer } from './Timer'
import './StatusBar.css'

@connect(
    null,
    {
        navigate: push
    }
)
@translate()
export class McGameStatusBar extends PureComponent {
    componentWillMount() {
        this.refreshBreadcrumb(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.game !== this.props.game) {
            this.refreshBreadcrumb(nextProps)
        }
    }
    refreshBreadcrumb = props => {
        const {
            game: { totalSeasons, totalRaces, currentSeason, currentRace, phase },
            t
        } = props
        if (typeof currentSeason === 'number' && typeof currentRace === 'number' && phase) {
            this.breadCrumbItems = flatten([
                currentRace === 1 && phase !== PHASE.POST_SEASON ? t('statusBar.breadCrumb.step1') : [],
                t('statusBar.breadCrumb.step2'),
                t('statusBar.breadCrumb.step3'),
                t('statusBar.breadCrumb.step4'),
                phase === PHASE.POST_SEASON ? t('statusBar.breadCrumb.step5') : []
            ])
            this.phaseNumber = phaseToNumber(phase)
            this.breadCrumbCurrent = currentRace === 1 && phase !== PHASE.POST_SEASON ? this.phaseNumber : this.phaseNumber - 1
        } else {
            this.breadCrumbItems = null
            this.phaseNumber = 0
        }
    }

    render() {
        const {
            game: { gameCode, remainingSeconds, totalSeasons, totalRaces, currentSeason, currentRace, phase },
            navigate,
            t
        } = this.props
        return (
            <div className="StatusBar StatusBar-MC">
                <div className="StatusBar-Content flex row-stretch-center">
                    <div className="flex flex-grow row-stretch-center">
                        <div className="flex row-left-center">
                            <a onClick={() => navigate('/mc')}>{t('superadmin.back')}</a>
                        </div>
                        <div className="flex row-center">
                            <Text className="StatusBar-GameCode-Title">{t('statusBar.title')}</Text>
                        </div>
                        <div className="flex row-right-bottom">
                            <div className="flex row-right-center StatusBar-GameCode">
                                <span className="StatusBar-GameCode--label">{t('statusBar.code')}: </span>
                                <CopyToClipboard id="gamecode" textToCopy={gameCode} placement="right">
                                    <Text tag="span" className="StatusBar-GameCode--text">
                                        {gameCode}
                                    </Text>
                                    <Icon name="copy" className="StatusBar-GameCode--icon" />
                                </CopyToClipboard>
                            </div>
                            <a onClick={() => navigate('/mc')}>Sign out</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/McGameStatusBar.js